import './assets/main.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus';

import App from './App.vue'
import router from './router/index.js'
import { initSentry } from './sentry.js'

import uk from './locale/uk.js'
import dayjs from 'dayjs'
import 'dayjs/locale/uk'
import can from './directives/can.js'   

dayjs.locale('uk')

const app = createApp(App)

initSentry(app, { router, serviceName: 'admin-ui' })
app.directive('can', can)

app.use(createPinia())
//app.use(ElementPlus)
app.use(router)
app.use(ElementPlus, { locale: uk })
app.mount('#app')

